import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class IzdatniceSirovinaService {
  constructor(private _http: HttpClient) {}

  dohvatiSkladistaSirovina(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'poslovnicaPopis', a)
      .pipe(map((res: any) => res));
  }
  
  dohvatiSveLinije(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_sve_linije', a)
      .pipe(map((res: any) => res));
  }

  dohvatiStavkeIzdatnicaSirovina(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'rekapitulacijaFilter', a)
      .pipe(map((res: any) => res));
  }
  
}
